module.exports = __webpack_public_path__ + "img/Social_6.d0084a0d.webp";